export const searchModuleColumns = [
  {
    column: "statusName",
    title: "Status",
    filter: "text",
    isShown: true,
    canBeHidden: true
  },
  {
    column: "typeName",
    title: "Lead Type",
    filter: "text",
    isShown: true,
    canBeHidden: true
  },
  {
    column: "specialist",
    title: "Specialist",
    filter: "text",
    isShown: true,
    canBeHidden: true
  },
  {
    column: "lastActivity",
    title: "Last Activity",
    filter: "date",
    isShown: true,
    canBeHidden: true
  },
  {
    column: "financeType",
    title: "Finance Type",
    filter: "text",
    isShown: true,
    canBeHidden: true
  },
  {
    column: "customerName",
    title: "Customer name",
    filter: "text",
    isShown: true,
    canBeHidden: true
  },
  {
    column: "bank",
    title: "Bank/Seller",
    filter: "text",
    isShown: true,
    canBeHidden: true
  }
];
